((Alert, $) => {
  'use strict';

  let $alert;

  const cacheDom = () => {
    $alert = $('.alert-message');
  };

  const showAlert = () => {
    $alert.show().delay(2000).fadeOut('slow');
  };

  const checkFormSubmissionParameter = () => {
    if(window.location.search.indexOf('formSubmitted=true') !== -1) {
      showAlert();
    }
  };

  const init = () => {
    cacheDom();
    checkFormSubmissionParameter();
  };

  Alert.init = init;
  Alert.showAlert = showAlert;
})(window.Alert = window.Alert || {}, jQuery);
